import { useState } from "react";
import { Outlet } from "react-router-dom";
import Card from "../../Components/Card/Card";
import CmsThemeProvider from "../../Components/cms/CmsThemeProvider";
import styleLayout from "./CmsLayout.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import "../../styles/cms-content.css";

const CmsLayout = ({ user }) => {
  const [visibility, setVisibility] = useState(false);

  return (
    <CmsThemeProvider>
      <div className={styleLayout.dashboard}>
      <div
        className={`${styleLayout.sidebarShell} ${
          visibility ? styleLayout.sidebarShellOpen : ""
        }`}
      >
        <Sidebar
          visibility={visibility}
          setVisibility={setVisibility}
          user={user}
        />
      </div>

      <main className={styleLayout.dashboardMain}>
        <Navbar setVisibility={setVisibility} user={user} />
        <div className={styleLayout.contentWrapper}>
          <Card>
            <Outlet />
          </Card>
        </div>
      </main>

      {visibility && (
        <div
          className={styleLayout.overlay}
          onClick={() => setVisibility(false)}
          aria-hidden="true"
        />
      )}
      </div>
    </CmsThemeProvider>
  );
};

export default CmsLayout;
